module.exports = __webpack_public_path__ + "static/media/helmet-battle.a831f5d1.svg";